export const logoutRequestB2C = {
    postLogoutRedirectUri: '/',
};
